
export const SET_DATA = 'SET_DATA'
export const SET_META = 'SET_META'
export const ADD_DATA = 'ADD_DATA'
export const REMOVE_DATA = 'REMOVE_DATA'
export const CLEAR_DATA = 'CLEAR_DATA'
export const SET_COLUMNS = 'SET_COLUMNS'
export const SET_SORT_BY = 'SET_SORT_BY'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_SELECTED = 'SET_SELECTED'
export const CLEAR_SELECTED = 'CLEAR_SELECTED'
export const SET_ORIGINAL_COLUMNS = 'SET_ORIGINAL_COLUMNS'
export const SET_SORT_ORDER = 'SET_SORT_ORDER'
